import { put, call } from 'redux-saga/effects';
import * as actions from '../actions';
import { checkSession } from '../../api/application';
import { getClientId } from '../reducers/loadClientStyleReducer';

export function* fetchClientIdSaga(action) {
    try {
        const response = yield call(checkSession, action.sessionId, action.skipStatusCheck);

        yield put({type: actions.loadClientStyleStyleSuccess(response.data)});

        yield put(actions.loadClientId(getClientId(response.data.data.clientId, response.data.data.make)));
        yield put(actions.loadCustomerFlow(response.data.data.customerFlow));
        // Error Code = 1 - Expired
        // Error Code = 0 - Inactive
        if (response.data.data.errorCode === 1) {
            yield put(actions.stageSuccess(10));
        } else if (response.data.data.errorCode === 0) {
            if (response.data?.data?.customerFlow === true && response.data?.data?.callbackUrl) {
                window.location = response.data?.data?.callbackUrl;
            } else {
                yield put(actions.stageSuccess(9));
            }
        }
    } catch (error) {
        if (error?.data) {
            yield put({ type: actions.loadClientStyleStyleFailed(error.data.msg) });
        }
    }
}
